import { useMatch, Routes, Route, Navigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { ArrowBack, AssignmentLate } from "@mui/icons-material";
import BasicData from "./pages/BasicInfo";
import ShopPages from "./pages/types";
import Sidenav from "../../components/Sidebar/Sidenav";
import NavItem from "../../components/Sidebar/NavItem";
import useShops from "../../hooks/data/useShops";
import { useFetch } from "../../hooks";
import { useShopContext } from "../../contexts/ShopContext";

const ShopRouter = (): JSX.Element => {
  const { pathnameBase } = useMatch({ path: '/shops/:id/*' })!;

  return (
    <Routes>
      <Route path="/" element={<Navigate to={`${pathnameBase}/basic-info`} replace />} />
      <Route path="/basic-info" element={<BasicData />} />
    </Routes>
  );
};

export const Shop = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const repository = useShops();
  const { setShop, setLoading, handleUnselectShop } = useShopContext();

  const { data, loading, refetch } = useFetch((selectedId?: string) => repository.fetchById((selectedId ?? id)!), {
    ignoreFirstCall: true,
  });

  const [activePage, setActivePage] = useState<ShopPages>();
  const match = useMatch({ path: '/shops/:id/*' });

  const getActivePage = useCallback((page: ShopPages) => page === activePage, [activePage]);

  useEffect(() => {
      if (match) {
        const { pathnameBase, pathname: _path } = match;
        const initialRoute = _path.replace(pathnameBase, '').replace('/', '');
        setActivePage(initialRoute as ShopPages);
      }
  }, [match]);

  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  useEffect(() => {
    setShop(data ?? null);
  });

  useEffect(() => {
    if (id !== 'new') {
      refetch(id);
    }
  }, [id, refetch]);
  return (
    <>
    <Sidenav>
            <>
              <NavItem title="voltar" icon={<ArrowBack />} onClick={() => handleUnselectShop()} />
              <NavItem
                title="dados básicos"
                icon={<AssignmentLate />}
                active={getActivePage(ShopPages.BasicInfo)}
              />
            </>
          </Sidenav>
    <ShopRouter />
    </>
  );
};

export default Shop;
